/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
	Container,
	Row,
	Col,
	FormGroup,
	Label,
	Card,
	CardBody,
	Input,
} from 'reactstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {
	CloseOutlined,
	CloudDownloadOutlined,
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
} from '@mui/icons-material';
import { toast } from 'react-toastify';
import Pagination from 'react-js-pagination';
import InputAutoSelect from '~/components/InputAutoSelect';
import { ExtratoContext } from '~/context/ExtratoContext';
import {
	RecebimentosSimples,
	CardSimples,
} from '~/components/RecebimentosData/RecebimentosSimples';
import {
	RecebimentosGrupo,
	CardGrupo,
} from '~/components/RecebimentosData/RecebimentosGrupo';
import {
	RecebimentosSplit,
	CardSplit,
} from '~/components/RecebimentosData/RecebimentosSplit';
import { LoaderLista, LoaderMini } from '~/components/Loaders';
import { dataFinalAnteriorInicial } from '~/helpers/date';

import ReactGA from 'react-ga4';
import { FilterAndDown, TextClick, ButtonStyled } from './styles';
import { RecebimentosContext } from '../../../context/RecebimentosContext';



export default function Recebimentos(props) {
	const { user, isMobile } = props;
	const projetos = ['Programa QD'];

	const {
		filtroTipo,
		setFiltroTipo,
		documentoTitular,
		setDocumentoTitular,
		recebimentosCard,
		gruposTitularConcatenado,
		getRecebimentosGeral,
		recebimentosGrupo,
		recebimentosGeral,
		authenticationGroup,
		loadingRecebimentos,
		setLoadingRecebimentos,
		setLoaderRecebimentos,
		loaderRecebimentos,
		totalGrupos,
		getExport,
		authToken,
	} = useContext(RecebimentosContext);

	const {
		revendaHierarquiaList,
		getHierarquiaByDoc
	} = useContext(ExtratoContext);


	const [params, setParams] = useState({
		dateInit: moment().format('YYYY-MM-DD'),
		dateEnd: moment().format('YYYY-MM-DD'),
	});
	const [dataRange, setDataRange] = useState({
		dateInit: '',
		dateEnd: '',
	});
	const [button, setButton] = useState({
		hoje: true,
		dias7: false,
	});
	const [pagina, setPagina] = useState(1);
	const [paginaGrupo, setPaginaGrupo] = useState(1);
	const [gruposPage, setGruposPage] = useState([]);
	const [idTitular, setIdTitular] = useState(
		user.dados.tipo_cliente === 'grupo' ? 'todos' : user.dados.lojista_id
	);
	const [cargo, setCargo] = useState('');
	const [filtroRevendaHierarquia, setFiltroRevendaHierarquia] = useState('');

	useEffect(() => {
		if (dataRange.dateEnd !== '') {
			if (dataFinalAnteriorInicial(dataRange.dateInit, dataRange.dateEnd)) {
				toast.warning('Data final não pode ser anterior a data inicial');
				setDataRange({
					dateInit: '',
					dateEnd: '',
				});
			} else {
				updateDateFilter();
				handleFiltroDataGA4();
			}
		}
	}, [dataRange]);

	useEffect(() => {
		const cargoUser = user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.cargo.toLowerCase() !== 'distribuidor - filial' ? 'participante' : 'revenda';
		setCargo(cargoUser)
		if(cargoUser === 'participante' && revendaHierarquiaList.length === 0){
			getHierarquiaByDoc(user.dados.documento)
		}
	}, []);
	// eslint-disable-next-line consistent-return
	const tableRecebimento = (tipoCliente) => {
		switch (tipoCliente) {
			case 'simples':
				return (
					<RecebimentosSimples
						user={user}
						projetos={projetos}
						recebimentos={recebimentosGeral}
						loadingRecebimentos={loadingRecebimentos}
					/>
				);
			case 'grupo':
				return (
					<RecebimentosGrupo
						user={user}
						titular={idTitular}
						projetos={projetos}
						recebimentos={gruposPage}
						loadingRecebimentos={loadingRecebimentos}
					/>
				);
			case 'split':
				return (
					<RecebimentosSplit
						user={user}
						projetos={projetos}
						dadosSplit={recebimentosCard.split}
						recebimentos={recebimentosGeral}
						loadingRecebimentos={loadingRecebimentos}
					/>
				);
			default:
				break;
		}
	};

	function handlerPagination(page) {
		if (user.dados.tipo_cliente === 'grupo') {
			setPaginaGrupo(page);
			setGruposPage(recebimentosGrupo.listaConcatenadaGrupo[page - 1]);
		} else if (
			user.dados.tipo_cliente === 'simples' ||
			user.dados.tipo_cliente === 'split'
		) {
			setPagina(page);
			getRecebimentosGeral('', params, page, documentoTitular, filtroRevendaHierarquia);
		}
	}

	function updateDateFilter() {
		setButton({
			hoje: false,
			dias7: false,
		});

		setParams({
			dateInit: moment(dataRange.dateInit).format('YYYY-MM-DD'),
			dateEnd: moment(dataRange.dateEnd).format('YYYY-MM-DD'),
		});

		setPagina(1);
		setPaginaGrupo(1);
	}

	function handlerFiltrarHoje() {
		setButton({
			hoje: true,
			dias7: false,
		});
		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});
		setPagina(1);
		setPaginaGrupo(1);
		handleFiltroHojeGA4();
	}

	function handlerFiltrar7Dias() {
		setButton({
			hoje: false,
			dias7: true,
		});
		setDataRange({
			dateInit: '',
			dateEnd: '',
		});
		setParams({
			dateInit: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});
		setPagina(1);
		setPaginaGrupo(1);
		handleFiltro7DiasGA4();
	}

	const handleChangeCheckBox = (event) => {
		setFiltroTipo(event.target.value);
		setPagina(1);
	}

	function handlerLimparFiltro() {
		setFiltroRevendaHierarquia("")
		setButton({
			hoje: true,
			dias7: false,
		});
		setDataRange({
			dateInit: '',
			dateEnd: '',
		});
		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});
		setPagina(1);
		setPaginaGrupo(1);
		setIdTitular(
			user.dados.tipo_cliente === 'grupo'
				? 'todos'
				: user.dados.lojista_id
		);
	}

	function sizeFiltros() {
		if (user.dados.tipo_cliente === 'grupo'
			|| (user.dados.cargo.toLowerCase() === 'industria' && user.dados.tipo_projeto.toLowerCase() === 'intelbras')
			|| (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.tipo_projeto.toLowerCase() === 'iquine')) {
			return '4';
		}
		if (user.dados.permissoes.view_pgm) {
			return '5';
		}
		if (user.dados.permissoes.view_filtro_cupom) {
			return '6';
		}
		return '7';
	}

	function handleClickDownloadRecebimentosGA4() {
		ReactGA.event({
			category: "download_recebimento_click",
			action: "Download Recebimentos",
			label: "Baixando planilha de recebimentos",
		});
	}

	function handleFiltroHojeGA4() {
		ReactGA.event({
			category: "filtro_hoje_recebimentos_click",
			action: "Filtro Hoje Recebimentos",
			label: "Filtrando Hoje Recebimentos",
		});
	}

	function handleFiltro7DiasGA4() {
		ReactGA.event({
			category: "filtro_7dias_recebimentos_click",
			action: "Filtro 7 dias Recebimentos",
			label: "Filtrando 7 dias Recebimentos",
		});
	}

	function handleFiltroDataGA4() {
		ReactGA.event({
			category: "filtro_data_recebimentos_click",
			action: "Filtro por data Recebimentos",
			label: "Filtrando por data Recebimentos",
		});
	}

	function handleFiltroTitularGA4() {
		ReactGA.event({
			category: "filtro_titular_recebimentos_click",
			action: "Filtro por titular Recebimentos",
			label: "Filtrando por titular Recebimentos",
		});
	}

	const ColData = (
		<>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data inicial"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block notranslate"
						selected={dataRange.dateInit}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateInit: value,
							})
						}
					/>
				</FormGroup>
			</Col>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data final"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block w-100 notranslate"
						selected={dataRange.dateEnd}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateEnd: value,
							})
						}
					/>
				</FormGroup>
			</Col>
		</>
	)


	useEffect(() => {
		setGruposPage(recebimentosGrupo.listaConcatenadaGrupo[paginaGrupo - 1]);
	}, [recebimentosGeral, recebimentosGrupo, gruposPage]);

	useEffect(() => {
		setLoadingRecebimentos(true);
		authenticationGroup(params, pagina, idTitular, documentoTitular, filtroTipo, filtroRevendaHierarquia);
	}, [params, user.dados.user_id, pagina, idTitular, documentoTitular, filtroTipo, filtroRevendaHierarquia]);

	const options = useMemo(() =>[{"documento": "","nome": "Todos"}, ...revendaHierarquiaList], [revendaHierarquiaList]);
	const selectedValue = options.find(opt => opt?.documento === filtroRevendaHierarquia) || null;

	const optionsGrupo = useMemo(() =>[{id: null, grupo: {"documento": "","nome": "Todos"}}, ...gruposTitularConcatenado], [gruposTitularConcatenado]);
	const selectedValueGrupo = optionsGrupo.find(opt => opt?.grupo?.documento === documentoTitular) || null;

	return (
		<Container fluid>
			<Card
				style={{
					boxShadow: 'unset',
					borderRadius: '0px 18px 18px 18px',
				}}>
				<CardBody>
					<Row>
						<Col md="4" sm="12">
							<FormGroup>
								<Label className="d-block">
									Filtrar por período
								</Label>
								<Row>
									<Col>
										<ButtonStyled
											className="w-100 my-0"
											disabled={button.hoje}
											onClick={() =>
												handlerFiltrarHoje()
											}>
											Hoje
										</ButtonStyled>
									</Col>
									<Col>
										<ButtonStyled
											className="w-100 my-0"
											disabled={button.dias7}
											onClick={() =>
												handlerFiltrar7Dias()
											}>
											7 dias
										</ButtonStyled>
									</Col>
								</Row>
							</FormGroup>
						</Col>
						<Col
							md={sizeFiltros()}
							sm="12">
							<FormGroup>
								<Label className="d-block notranslate">
									Filtrar por data
								</Label>
								{!isMobile ?
									<Row>
										{ColData}
									</Row>
									: <>{ColData}</>
								}
							</FormGroup>
						</Col>
						{(user.dados.cargo.toLowerCase() === 'industria' && user.dados.tipo_projeto.toLowerCase() === 'intelbras') || (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && user.dados.tipo_projeto.toLowerCase() === 'iquine') ?
							<Col md="3" sm="12">
								<FormGroup>
									<Label className="d-block">
										Filtrar por Titular
									</Label>
									<Row>
										<Col>
											<FormGroup className="d-flex flex-column">
												<InputAutoSelect
													options={optionsGrupo}
													getOptionLabel={(item) => `${item?.grupo?.documento  || ''}${item?.grupo?.documento ? ' - ' : ''}${item?.grupo?.nome  || ''}` || ''}
													isOptionEqualToValue={(option, value) => {
														return option?.grupo?.documento === value;
													}}
													value={selectedValueGrupo}
													onChangeOption={(evt, select) => {
														setDocumentoTitular(
															select?.grupo?.documento  || ''
														);
														handleFiltroTitularGA4();
													}}
												/>

											</FormGroup>
										</Col>
									</Row>
								</FormGroup>
							</Col>
							:
							<>
								{cargo === 'participante'
									&& revendaHierarquiaList.length > 0 &&
									<Col xs="12" md="2" lg="9">
										<FormGroup>
											<Label style={{ fontWeight: 'bold' }}>Filtrar por Revenda: </Label>
											<InputAutoSelect
												options={options}
												getOptionLabel={(item) => `${item?.documento  || ''}${item?.documento ? ' - ' : ''}${item?.nome  || ''}` || ''}
												isOptionEqualToValue={(option, valueSelect) => option?.documento === valueSelect}
												value={selectedValue}
												onChangeOption={(evt, select) => {
													setFiltroRevendaHierarquia(select?.documento || '')
												}}
											/>
										</FormGroup>
									</Col>
								}
							</>
						}
						{false &&
							// {user.dados.permissoes.view_filtro_cupom &&
							<Col xs="12" md="2">
								<Label className="d-block">Filtrar por cupom</Label>
								<FormGroup className="d-flex flex-column">
									<Input
										type="select"
										onChange={handleChangeCheckBox}>
										<option value="todos">Todos</option>
										<option key={1} value={1}>Loja</option>
										<option key={0} value={0}>QD</option>
									</Input>
								</FormGroup>
							</Col>
						}



					</Row>
				</CardBody>
			</Card>

			{user.dados.tipo_cliente === 'simples' && recebimentosGeral && (
				<CardSimples
					recebimentos={recebimentosGeral}
					loadingRecebimentos={loadingRecebimentos}
				/>
			)}

			{user.dados.tipo_cliente === 'grupo' && (
				<CardGrupo
					recebimentos={gruposPage}
					totalGrupos={totalGrupos}
					loadingRecebimentos={loadingRecebimentos}
				/>
			)}

			{user.dados.tipo_cliente === 'split' && recebimentosGeral && (
				<>
					<CardSplit
						user={user}
						dadosSplit={recebimentosCard.split}
						recebimentos={recebimentosGeral}
						loadingRecebimentos={loadingRecebimentos}
					/>
				</>
			)}
			<Row className="mt-5">
				<Col>
					<LoaderLista
						loading={loadingRecebimentos}
						lista={
							recebimentosGrupo && gruposPage
								? gruposPage
								: recebimentosGeral.lista
						}
						error={recebimentosGeral.error}>
						<FilterAndDown>
							{/* {user.dados.tipo_projeto.toLowerCase() === 'intelbras' &&
								<> */}
							{user.dados.tipo_cliente === 'grupo' ? (
								!loaderRecebimentos ? (
									<TextClick
										tabIndex="0"
										role="button"
										onClick={() => {
											setLoaderRecebimentos(true);
											authToken().then((res) => {
												getExport(
													idTitular,
													res.data.id_token,
													params,
													documentoTitular,
													filtroTipo,
													filtroRevendaHierarquia
												);
												handleClickDownloadRecebimentosGA4();
											});
										}}>
										<CloudDownloadOutlined className="mr-1" />
										Fazer Download
									</TextClick>
								) : (
									<LoaderMini />
								)
							) : !loaderRecebimentos ? (
								<TextClick
									tabIndex="0"
									role="button"
									onClick={() => {
										setLoaderRecebimentos(true);
										authToken().then((res) => {
											getExport(
												user.dados.user_id,
												res.data.id_token,
												params,
												documentoTitular,
												filtroTipo,
												filtroRevendaHierarquia
											);
											handleClickDownloadRecebimentosGA4();
										});
									}}>
									<CloudDownloadOutlined className="mr-1" />
									Fazer Download
								</TextClick>
							) : (
								<LoaderMini />
							)}
							{/* </>
							} */}

							<TextClick
								tabIndex="0"
								role="button"
								onKeyPress={() => handlerLimparFiltro()}
								onClick={() => handlerLimparFiltro()}>
								<CloseOutlined className="mr-1" />
								Limpar filtros
							</TextClick>
						</FilterAndDown>

						{/* Tabela de Listagem */}
						<div className="table-responsive">
							{tableRecebimento(user.dados.tipo_cliente)}
						</div>

						<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
							{user.dados.tipo_cliente === 'simples' ||
								user.dados.tipo_cliente === 'split' ? (
								<Pagination
									activePage={pagina}
									totalItemsCount={
										recebimentosGeral.dados.total_registros
											? recebimentosGeral.dados
												.total_registros
											: 0
									}
									onChange={(page) => handlerPagination(page)}
									prevPageText={<ChevronLeftOutlined />}
									nextPageText={<ChevronRightOutlined />}
									firstPageText={<FirstPageOutlined />}
									lastPageText={<LastPageOutlined />}
								/>
							) : (
								// eslint-disable-next-line react/jsx-no-useless-fragment
								<></>
							)}

							{user.dados.tipo_cliente === 'grupo' && (
								<Pagination
									activePage={paginaGrupo}
									totalItemsCount={
										recebimentosGrupo.listaConcatenadaGrupo
											.length
											? recebimentosGrupo
												.listaConcatenadaGrupo
												.length
											: 0
									}
									onChange={(page) => handlerPagination(page)}
									itemsCountPerPage={1}
									prevPageText={<ChevronLeftOutlined />}
									nextPageText={<ChevronRightOutlined />}
									firstPageText={<FirstPageOutlined />}
									lastPageText={<LastPageOutlined />}
								/>
							)}
						</div>
					</LoaderLista>
				</Col>
			</Row>
		</Container>
	);
}
